import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {plainToClass, classToClass} from "class-transformer";
import {SelectItem} from "primeng/api";

import {GrowlService} from "@app/core";
import {Calendar} from "@app/shared/calendar/calendar";
import {DialogStyle65, DTColumn} from "@app/shared/classes/common";
import {ProjectRevenueBalance, RevenueBalanceType} from "@app/shared/classes/project";
import {ApprovalStatusType} from "@app/shared/enums/approval-status-type.enum";
import {Transaction} from "@app/shared/enums/txn-type.enum";
import {Format} from "@app/shared/enums/format.enum";
import {Validation} from "@app/shared/enums/validation.enum";
import {BillingType} from "@app/shared/enums/billing-type.enum";
import {CalendarType} from "@app/shared/enums/calendar-type.enum";
import {GrowlType} from "@app/shared/enums/growl-type.enum";
import { CalendarService } from '../services/calendar.service';
import { ProjectService } from '../services/project.service';
import {SolutionManagerDataService} from "@app/solution-manager/solution-manager-data.service";


@Component({
  selector: 'app-revenue-balance',
  templateUrl: './revenue-balance.component.html',
  styleUrls: ['./revenue-balance.component.css'],
  providers: [SolutionManagerDataService, ProjectService]
})
export class RevenueBalanceComponent implements OnInit, OnChanges {

  @Input() projectId: number;
  @Input() contractId: number;
  @Input() clinId: number;
  @Input() clinOrProjectName: string;
  @Input() displayRevenueBalanceDialog: boolean;
  @Input() inSolutionManager: boolean;
  @Input() goLiveAccountingPeriodClosed: boolean;
  @Input() revenueBalanceType: RevenueBalanceType;
  orgAccountingCalendarBeforeGoLive: Calendar;
  @Output() handler: EventEmitter<any> = new EventEmitter();
  // TODO: What is this for?
  taskBalanceTable: string[] = ["employee"];
  clinsDropDown: SelectItem[] = [];

  DialogStyle65 = DialogStyle65;
  ApprovalStatusType: typeof ApprovalStatusType = ApprovalStatusType;
  Format: typeof Format = Format;
  Transaction: typeof Transaction = Transaction;


  saveOrUpdateProjectTaskBalanceButton: boolean;
  accountingPeriodDropdown: SelectItem[];
  Validation: typeof Validation = Validation;
  BillingType: typeof BillingType = BillingType;
  RevenueBalanceType: typeof RevenueBalanceType = RevenueBalanceType;
  revenueBalanceColumns: DTColumn[] = [];
  currentYear: string;



  selectedRevenue: ProjectRevenueBalance = new ProjectRevenueBalance();
  selectedRevenueList: ProjectRevenueBalance[] = [];

  constructor(private dataService: SolutionManagerDataService, private calendarService: CalendarService, private growl: GrowlService, private projectService: ProjectService) {
  }

  ngOnInit() {
    this.dataService.getAccountingCalendarBeforeGoLive(CalendarType.Accounting, this.inSolutionManager).subscribe(res => {
      this.orgAccountingCalendarBeforeGoLive = res;
    });

    this.calendarService.getCurrentFiscalYear().subscribe(res => {
      this.currentYear = String(res);
    });

    this.revenueBalanceColumns = [
      { field: 'clinId', header: 'CLIN' },
      { field: 'priorYearRevenueITD', header: 'Prior Year Revenue ITD' },
      { field: 'currentYearRevenueYTD', header: 'Current Year Revenue YTD' },
      { field: 'currentYearRevenueITD', header: 'Current Year Revenue ITD' },
      { field: 'priorYearFeeITD', header: 'Prior Year Fee ITD' },
      { field: 'currentYearFeeYTD', header: 'Current Year Fee YTD' },
      { field: 'currentYearFeeITD', header: 'Current Year Fee ITD' },
    ];

  }

  ngOnChanges(changes: SimpleChanges): void {
    this.searchInitialRevenue();
    if (this.contractId) {
      this.projectService.getClinInfoAsDropdown(this.contractId, true).subscribe(res => {
        this.clinsDropDown = res;
        this.filterClin(this.selectedRevenueList);

      });
    }

  }

  searchInitialRevenue() {
    if (this.revenueBalanceType == RevenueBalanceType.Project || this.revenueBalanceType == RevenueBalanceType.FirmFixedClin) {
      this.dataService.getFirmFixedInitialRevenue(this.clinId, this.projectId, this.inSolutionManager).subscribe(res => {
        this.selectedRevenue = plainToClass(ProjectRevenueBalance, res);
        if (!this.selectedRevenue) {
          this.selectedRevenue = new ProjectRevenueBalance();
          this.calendarService.getCurrentFiscalYear().subscribe(res => {
            this.selectedRevenue.currentYear = String(res);
          });
        }
      });
    } else if (this.revenueBalanceType == RevenueBalanceType.ProjectClin) {
      this.dataService.getOtherInitialRevenue(this.clinId, this.projectId, this.inSolutionManager).subscribe(res => {
        this.selectedRevenueList = plainToClass(ProjectRevenueBalance, res );
        if (!this.selectedRevenueList) {
          this.selectedRevenueList = [];
        }
        if (this.contractId) {
          this.projectService.getClinInfoAsDropdown(this.contractId, true).subscribe(res => {
            this.clinsDropDown = res;
            this.filterClin(this.selectedRevenueList);
          });
        }
      });

    }

  }

  filterClin(selectedRevenueList: ProjectRevenueBalance[]) {
    for (let revenue of selectedRevenueList) {
      let index = this.clinsDropDown.findIndex(clin => clin.value == revenue.clinId);
      if (index > -1) {
        this.clinsDropDown.splice(index, 1);
      }
    }
  }

  addItem() {
    let revenue = new ProjectRevenueBalance();
    revenue.currentYear = this.currentYear;
    revenue.projectId = this.projectId;
    this.selectedRevenueList.push(classToClass(revenue));
    console.log(this.selectedRevenueList);
  }



  setCurrentYearITD(selectedRevenue: ProjectRevenueBalance) {
    selectedRevenue.currentYearRevenueITD = selectedRevenue.currentYearRevenueYTD + selectedRevenue.priorYearRevenueITD;
    selectedRevenue.currentYearFeeITD = selectedRevenue.currentYearFeeYTD + selectedRevenue.priorYearFeeITD;

  }

  setProjectOrClinId() {
    if (this.clinId) {
      this.selectedRevenue.clinId = this.clinId;
    } else {
      this.selectedRevenue.projectId = this.projectId;
    }
  }


  saveOrUpdateRevenueList() {
    for (let selectedRevenue of this.selectedRevenueList) {
      this.setCurrentYearITD(selectedRevenue);
    }
    this.saveOrUpdateRevenues(this.selectedRevenueList);
  }

  saveRevenue() {
    this.setProjectOrClinId();
    this.setCurrentYearITD(this.selectedRevenue);
    this.saveInitialRevenueToDB(this.selectedRevenue);
  }

  updateRevenue() {
    this.setProjectOrClinId();
    this.setCurrentYearITD(this.selectedRevenue);
    this.updateRevenueToDB(this.selectedRevenue);

  }

  saveInitialRevenueToDB(selectedRevenue: ProjectRevenueBalance) {
    this.dataService.saveInitialRevenue(selectedRevenue, this.inSolutionManager).subscribe(res => {
      this.growl.add(GrowlType.Success, "Revenue added.");
      this.hideDialog();
    });
  }

  updateRevenueToDB(selectedRevenue: ProjectRevenueBalance) {
    this.dataService.updateInitialRevenue(selectedRevenue, this.inSolutionManager).subscribe(res => {
      this.growl.add(GrowlType.Success, "Revenue updated.");
      this.hideDialog();
    });
  }

  saveOrUpdateRevenues(selectedRevenues: ProjectRevenueBalance[]) {
    this.dataService.saveOrUpdateRevenues(selectedRevenues, this.inSolutionManager).subscribe(res => {
      this.growl.add(GrowlType.Success, "Revenue updated.");
      this.hideDialog();
    });
  }


  hideDialog(event?) {
    this.displayRevenueBalanceDialog = false;
    this.handler.emit('hide dialog');
  }

  cancelRevenueDialog() {
    this.displayRevenueBalanceDialog = false;
    this.handler.emit(null);
    // this.hideDialog();
  }

}
